import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Search filters
 */
export class SearchFilters extends ApiRequestFilters {}
